export * from './App'

export const Store = {
  Info: null,
  Menu: {}
}

export const Tag = {
  Info: null,
  Menu: {}
}
